<template>
  <div class="row align-items-center col-lg-8">
      <date-picker
        v-model="date"
        format="jYYYY/jMM/jDD"
        class="p-pay-representation-time-select-left"
      />
  </div>
</template>

<script>


export default {
  name: 'startEndSelectTime',
  props: {
    textTime                 : {type:String,default:''},
    checkStartEndTimeStatus  : {type:String,default:''},
  },

  data() {
    return {
      date : '',
    }
  },

  computed: {

  },

  watch: {
    date(date){
      const setDateData = {
        date   : date,
        status : this.checkStartEndTimeStatus,
      }

      this.$emit('selectedDate',setDateData);
    }
  },

  mounted () {

  },

  methods: {


  },

}
</script>
